module.exports = __webpack_public_path__ + "img/border-right.39166638.svg";